import { IS_MAC } from '../common/const'

const allActions = [
  {
    id: 'start-survey',
    name: 'Start a Survey',
    shortcut: ['S', 'S'],
    section: 'Navigation Shortcuts',
    perform: () => (window.location.pathname = '/surveys/new/')
  },
  {
    id: 'diy-tutorials',
    name: 'Go to DIY Tutorials',
    shortcut: ['D', 'I', 'Y'],
    section: 'Navigation Shortcuts',
    perform: () => (window.location.pathname = '/solutions/diy')
  },
  {
    id: 'lighthouse-academy',
    name: 'Go to Lighthouse Academy',
    shortcut: ['L', 'A'],
    section: 'Navigation Shortcuts',
    perform: () => (window.location.href = 'https://academy.aytm.com/')
  },
  {
    id: 'my-dashboard',
    name: 'Go to my Dashboard',
    shortcut: ['M', 'D'],
    section: 'Navigation Shortcuts',
    perform: () => (window.location.pathname = '/dashboard')
  },
  {
    id: 'solutions-center',
    name: 'Solutions Center',
    shortcut: ['S', 'C'],
    section: 'Navigation Shortcuts',
    perform: () => (window.location.pathname = '/solutions-center')
  },
  {
    id: 'collapse-expand-editor',
    name: 'Collapse All/Expand All',
    shortcut: ['C', 'A'],
    section: 'Editor Page Shortcuts',
    perform: () => {
      const button = document.querySelector<HTMLElement>('.surveyeditor-CollapseQuestionButton')
      if (button) button.click()
    }
  },
  {
    id: 'undo',
    name: `Undo`,
    shortcut: IS_MAC ? ['Command', 'Z'] : ['Ctrl', 'Z'],
    section: 'Editor Page Shortcuts informational'
  },
  {
    id: 'redo',
    name: 'Redo',
    shortcut: IS_MAC ? ['Command', 'Shift', 'Z'] : ['Ctrl', 'Y'],
    section: 'Editor Page Shortcuts informational'
  },
  {
    id: 'clone-field',
    name: 'Clone a Field',
    shortcut: ['Drag', 'Shift', 'Double-click', 'cloning', 'clone'],
    section: 'Editor Page Shortcuts informational',
    subtitle: 'or'
  },
  {
    id: 'copy',
    name: 'Copy',
    shortcut: IS_MAC ? ['Command', 'C'] : ['Ctrl', 'C'],
    section: 'Editor Page Shortcuts informational',
    subtitle: '(while text is selected)'
  },
  {
    id: 'paste',
    name: 'Paste',
    shortcut: IS_MAC ? ['Command', 'V'] : ['Ctrl', 'V'],
    section: 'Editor Page Shortcuts informational',
    subtitle: '(you can paste lists & images)'
  },
  {
    id: 'preview-survey',
    name: 'Preview Survey',
    shortcut: ['Ctrl', 'Shift', 'V'],
    section: 'Editor Page Shortcuts informational'
  },
  {
    id: 'prev-field',
    name: 'Previous Field',
    shortcut: ['Shift', 'Tab'],
    section: 'Editor Page Shortcuts informational'
  },
  {
    id: 'add-field',
    name: 'Add a Field',
    shortcut: ['Enter'],
    section: 'Editor Page Shortcuts informational',
    subtitle: '(while cursor is in the last field)'
  },
  {
    id: 'line-break',
    name: 'Line Break',
    shortcut: ['Shift', 'Enter'],
    section: 'Editor Page Shortcuts informational',
    subtitle: '(while cursor is in a question field)'
  },
  {
    id: 'scroll-to-question',
    name: 'Scroll to a Question',
    shortcut: ['Ctrl', 'Alt', '#'],
    section: 'Editor Page Shortcuts informational',
    subtitle: '(replace # with a number of Q)'
  },
  {
    id: 'select-question-range',
    name: 'Select Question Range',
    shortcut: ['Shift', 'click'],
    section: 'Editor Page Shortcuts informational',
    subtitle: '(while Question Library is open)'
  },
  {
    id: 'logic-autocomplete',
    name: 'Logic Autocomplete',
    shortcut: ['['],
    section: 'Editor Page Shortcuts informational',
    subtitle: '(while cursor is in a field)'
  },
  {
    id: 'hide-autocomplete',
    name: 'Hide Autocomplete',
    shortcut: ['Esc'],
    section: 'Editor Page Shortcuts informational'
  },
  {
    id: 'toggle-autocomplete',
    name: 'Toggle Autocomplete',
    shortcut: ['Ctrl', '['],
    section: 'Editor Page Shortcuts informational'
  },
  {
    id: 'open-exports',
    name: 'Open Exports',
    shortcut: ['E'],
    section: 'Results Page Shortcuts',
    perform: () => {
      const exportButton = document.querySelector<HTMLElement>('#switch-export-panel')
      if (exportButton) exportButton.click()
    }
  },
  {
    id: 'hide-aytm-logic',
    name: 'Toggle Hide aytm Logic',
    shortcut: ['H', 'L'],
    section: 'Toggle Hide aytm Logic',
    perform: () => {
      const logicCheckbox = document.querySelector<HTMLElement>('[data-qlogic-visibility]')
      if (logicCheckbox) {
        logicCheckbox.click()
        const input = logicCheckbox.querySelector<HTMLElement>('input[type="checkbox"]')
        input?.blur()
      }
    }
  },
  {
    id: 'collapse-expand-results',
    name: 'Collapse All/Expand All',
    shortcut: ['C', 'A'],
    section: 'Results Page Shortcuts',
    perform: () => {
      const expandButton = document.querySelector<HTMLElement>('[data-view-toggle-collapse-all]')
      if (expandButton) {
        expandButton.click()
        const checkBox = expandButton.querySelector<HTMLElement>('input[type="checkbox"]')
        checkBox?.blur()
      }
    }
  }
]

function isEditorPage() {
  const path = window.location.pathname
  return /\/surveys\/\d+\/(edit|view)\/?$/.test(path)
}

function isResultsPage() {
  const path = window.location.pathname
  return /\/surveys\/\d+\/stat\/?$/.test(path)
}

export function getVisibleActions() {
  const sections = ['Navigation Shortcuts']

  if (isEditorPage()) {
    sections.push('Editor Page Shortcuts')
    sections.push('Editor Page Shortcuts informational')
  }

  if (isResultsPage()) {
    sections.push('Results Page Shortcuts')
    const exportVisibilityElement = document.querySelector('.cl_export_visibility')
    const isHidden = exportVisibilityElement?.classList.contains('hidden')
    if (exportVisibilityElement && !isHidden) {
      sections.push('Toggle Hide aytm Logic')
    }
  }

  return allActions.filter(action => sections.includes(action.section))
}
